module.exports = __webpack_public_path__ + "media/images/btn_supervised_accounts-3c55412e80628f8152fb8179390dfdf0.gif";